import React, { ReactNode } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, ViewStyle } from 'react-native';
import { COLORS } from '../constants/config';
import { useTheme } from '../contexts/ThemeContext';

interface CardProps {
  children: ReactNode;
  title?: string;
  onPress?: () => void;
  style?: ViewStyle;
  headerRight?: ReactNode;
}

export default function Card({ children, title, onPress, style, headerRight }: CardProps) {
  const { colors } = useTheme();
  const Container: React.ElementType = onPress ? TouchableOpacity : View;

  return (
    <Container
      style={[styles.card, { backgroundColor: colors.card, borderColor: colors.cardBorder, borderWidth: 1 }, style]}
      onPress={onPress}
      activeOpacity={0.7}
    >
      {title && (
        <View style={[styles.header, { borderBottomColor: colors.border }]}>
          <Text style={[styles.title, { color: colors.textPrimary }]}>{title}</Text>
          {headerRight}
        </View>
      )}
      <View style={styles.content}>{children}</View>
    </Container>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: COLORS.card,
    borderRadius: 12,
    // Use boxShadow for web compatibility
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    elevation: 3,
    marginBottom: 12,
  } as ViewStyle,
  header: {
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: COLORS.border,
  },
  title: {
    fontSize: 16,
    fontWeight: '600',
    color: COLORS.text,
    textAlign: 'right',
  },
  content: {
    padding: 16,
  },
});
